var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"signup-loading",attrs:{"aria-hidden":"true"}},[_c('div',{staticClass:"sl-logo"},[_c('SignupLoaderMark')],1),_vm._v(" "),_c('div',{staticClass:"sl-text"},[_vm._v(_vm._s(_vm.t('loading')))])])}
var staticRenderFns = []

export { render, staticRenderFns }